import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const Title = styled.p`
  font-weight: bold;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;

  .MuiTableCell-head {
    background-color: #0168b9,
    color: #FFFFFF !important
  }
`;

export const TextInLine = styled.p`
  flex: 1;
  flex-direction: column;
`;

export const Legend = styled.div`
  display: flex;
  // background-color: red;
  font-size: 14px;
  line-height: 0.8375em;
`;

export const IconButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 50%;
  margin-right: 4;
`;
